import { render, staticRenderFns } from "./BroadcastSmsList.vue?vue&type=template&id=b085ea54&"
import script from "./BroadcastSmsList.vue?vue&type=script&lang=js&"
export * from "./BroadcastSmsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports